import React, { useEffect, useState } from "react";
import {
  Container,
  TextField,
  Card,
  CardMedia,
  CardContent,
  Typography,
  InputAdornment,
  Modal,
  Box,
  Grid,
  IconButton
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import Signup from "../Videos/2025-05-29-08-28-47-Signup.mkv.mp4";
import Login from "../Videos/2025-05-29-09-43-59-Login.mkv.mp4";
import Validation from "../Videos/2025-06-10-09-30-10-Validation.mkv.mp4";
import ProofOfPayment from "../Videos/2025-05-30-10-58-00-proof-of-payment.mkv.mp4";
import CreateBid from "../Videos/2025-05-30-11-09-13-Create-Bid.mkv.mp4";
import Excel from "../Videos/2025-06-10-10-29-39-Excel.mkv.mp4";
import Upload from "../Videos/2025-06-02-12-24-26-Upload.mkv.mp4";

// modal style
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  p: 2
};

// Updated videos array using imported videos
const videos = [
  {
    id: "1",
    title: "Sign up",
    description: "Signup on the bidding site.",
    src: Signup
  },
  {
    id: "2",
    title: "Login",
    description: "Login to the bidding site.",
    src: Login
  },
  {
    id: "3",
    title: "Profile Validation",
    description: "Validate your profile before bidding.",
    src: Validation
  },
  {
    id: "4",
    title: "Proof of Payment",
    description: "Proof of Payment",
    src: ProofOfPayment
  },
  {
    id: "5",
    title: "Create Bid",
    description: "Creating the bid.",
    src: CreateBid
  },
  {
    id: "6",
    title: "Excel",
    description: "Filling out the excel.",
    src: Excel
  },
  {
    id: "7",
    title: "Upload",
    description: "Upload Bid.",
    src: Upload
  }
];

const ApplicationVideos = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState(null);
  const [thumbnails, setThumbnails] = useState({});

  const generateThumbnail = (videoSrc, callback) => {
    const video = document.createElement("video");
    video.src = videoSrc;
    video.crossOrigin = "anonymous";
    video.currentTime = 1;
    video.muted = true;
    video.playsInline = true;

    video.addEventListener("loadeddata", () => {
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageUrl = canvas.toDataURL("image/png");
      callback(imageUrl);
    });
  };

  useEffect(() => {
    videos.forEach((vid) => {
      if (!thumbnails[vid.src]) {
        generateThumbnail(vid.src, (thumb) => {
          setThumbnails((prev) => ({ ...prev, [vid.src]: thumb }));
        });
      }
    });
  }, []);

  const handleOpen = (video) => {
    setActiveVideo(video);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setActiveVideo(null);
  };

  const filteredVideos = videos.filter(
    (vid) =>
      vid.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      vid.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <TextField
        fullWidth
        size="small"
        placeholder="Search videos..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 3 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          )
        }}
      />

      <Grid container spacing={2}>
        {filteredVideos.map((video) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={video.id}>
            <Card
              onClick={() => handleOpen(video)}
              sx={{ cursor: "pointer", height: "100%" }}
            >
              <CardMedia
                component="img"
                image={thumbnails[video.src] || "/images/video-thumbnail.png"}
                alt={video.title}
                style={{
                  height: 120,
                  objectFit: "cover"
                }}
              />
              <CardContent>
                <Typography variant="subtitle1" fontWeight="bold">
                  {video.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" noWrap>
                  {video.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Modal open={open} onClose={handleClose}>
        <Box sx={modalStyle}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <Typography variant="h6">{activeVideo?.title}</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          {activeVideo && (
            <video
              src={activeVideo.src}
              controls
              autoPlay
              style={{ width: "100%", borderRadius: 8 }}
            >
              Your browser does not support the video tag.
            </video>
          )}
        </Box>
      </Modal>
    </Container>
  );
};

export default ApplicationVideos;
